/**
 * Operator Client
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export const BillingInterval = {
    Minute: 'Minute',
    Hour: 'Hour',
    Day: 'Day'
} as const;
export type BillingInterval = typeof BillingInterval[keyof typeof BillingInterval];

